import { render, staticRenderFns } from "./printHKDeliveryConfirms.vue?vue&type=template&id=4f5b2cc7&scoped=true&"
import script from "./printHKDeliveryConfirms.vue?vue&type=script&lang=js&"
export * from "./printHKDeliveryConfirms.vue?vue&type=script&lang=js&"
import style0 from "./printHKDeliveryConfirms.vue?vue&type=style&index=0&id=4f5b2cc7&lang=less&scoped=true&media=print&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5b2cc7",
  null
  
)

component.options.__file = "printHKDeliveryConfirms.vue"
export default component.exports